import React from "react";
import "./CertificationCard.css";
import { Fade } from "react-reveal";

function CertificationCard(props) {
  const certificate = props.certificate;
  const theme = props.theme;

  // Add 'dark-mode' class if theme.isDark is true
  const cardClassName = `cert-card ${theme.isDark ? "dark-mode" : ""}`;

  return (
    <Fade bottom duration={1000} distance="20px">
      <div
        className={cardClassName} // Use the dynamic class name
        style={{
          // Keep box-shadow logic, but other styles will be handled by CSS
          boxShadow: theme.isDark
            ? `0 8px 25px ${theme.accentBrighter}40`
            : `0 8px 25px ${theme.accentColor}40`,
        }}
      >
        <div className="content">
          <a
            href={certificate.certificate_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="content-overlay"></div>
            <div
              className="cert-header"
              style={{ background: certificate.color_code }}
            >
              <img
                className="logo_img"
                src={require(`../../assets/images/${certificate.logo_path}`)}
                alt={certificate.alt_name}
              />
            </div>
            <div className="content-details fadeIn-top">
              <div className="view-certificate">
                <span>View Certificate</span>
              </div>
            </div>
          </a>
        </div>
        <div className="cert-body">
          <h2
            className="cert-body-title"
            // Removed inline style for color
          >
            {certificate.title}
          </h2>
          <h3
            className="cert-body-subtitle"
            // Removed inline style for color
          >
            {certificate.subtitle}
          </h3>
        </div>
      </div>
    </Fade>
  );
}

export default CertificationCard;
